var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var generateError = function (message) { return "Relay SDK: ".concat(message); };
var SDK = /** @class */ (function () {
    function class_1(_fetch, id) {
        var _this = this;
        this.apiURL = 'https://relay-plantkit.vercel.app/api/';
        this.apiKey = '';
        this.id = '';
        this.init = function (data) {
            if (data.fetch) {
                _this.fetch = data.fetch;
            }
            if (data.apiURL) {
                _this.apiURL = data.apiURL;
                if (!_this.apiURL.endsWith('/')) {
                    _this.apiURL += '/';
                }
            }
            if (data.apiKey) {
                _this.apiKey = data.apiKey;
            }
        };
        this.sendEvent = function (data, params) { return __awaiter(_this, void 0, void 0, function () {
            var tags, rest, body;
            return __generator(this, function (_a) {
                tags = params.tags, rest = __rest(params, ["tags"]);
                if (rest === null || rest === void 0 ? void 0 : rest.apiKey) {
                    this.init(__assign(__assign({}, rest), { apiKey: rest.apiKey }));
                }
                this._validateSendEvent(data);
                body = JSON.stringify({
                    data: data,
                    tags: (tags || []).concat([this.id]),
                });
                return [2 /*return*/, (this.fetch || fetch)("".concat(this.apiURL, "submissions/"), {
                        body: body,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-Key': this.apiKey,
                        },
                        method: 'POST',
                    }).then(function (res) { return res.json(); })];
            });
        }); };
        if (_fetch) {
            this.fetch = _fetch;
        }
        this.id = id;
        if (!this.fetch && typeof fetch === 'undefined') {
            console.error('Fetch function is undefined');
        }
        if (!this.id) {
            console.error('ID is undefined');
        }
    }
    class_1.prototype._validateSendEvent = function (data) {
        if (!data) {
            throw new Error(generateError('Attempting to send null data'));
        }
        if (!this.apiKey) {
            throw new Error(generateError('Attempting to send data with no API key, make sure you set it in sendEvent or init'));
        }
        if (!this.fetch && typeof fetch === 'undefined') {
            throw new Error(generateError('Attempting to send data with no API key, make sure you set it in sendEvent or init'));
        }
    };
    return class_1;
}());
export default function getSDKInstance(fetch, id) {
    return new SDK(fetch, id);
}
